// extracted by mini-css-extract-plugin
export default {"segmentControl":"AITutorSegmentControl__segmentControl___FKVDA"};